(() => {
  const init = () => document.querySelectorAll('[data-flavor-gallery]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...track.children];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-index]')];
    if (slides.length < 2) return;
    let current = 0, frame;
    const update = () => {
      current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      gallery.querySelector('[data-gallery-count]').textContent = `${current + 1} / ${slides.length}`;
      thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(index === current)));
    };
    const go = index => {
      current = (index + slides.length) % slides.length;
      track.scrollTo({left: current * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => go(current - 1));
    gallery.querySelector('[data-gallery-next]').addEventListener('click', () => go(current + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => go(index)));
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    track.addEventListener('scroll', () => {cancelAnimationFrame(frame); frame = requestAnimationFrame(update);}, {passive: true});
    new ResizeObserver(() => track.scrollTo({left: current * track.clientWidth, behavior: 'instant'})).observe(track);
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
